import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Button, Col, Form, Row, Card, Select, Modal, message } from 'antd';
import Input from '../../ui/Input';
import TextArea from '../../ui/TextArea';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import { LocalPersistence } from '../../../factories';
import { updateOtherFeeTax, deleteOtherFeeTax } from '../../../services/otherPayments';
import PageContainer from '../../CSIComponents/PageContainer';
import DetailItem from '../../CSIComponents/DetailItem';
import Loading from '../../Loading';
import styles from '@components/Attraction/index.module.css';

const { Option } = Select;

const EditOtherFeeTax = (props: any) => {
  const [chargeName, setChargeName] = useState('');
  const [disableFlag, setDisableFlag] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  let chargeObj = { label: chargeName, value: props.rowData[`${chargeName}`], span: 6 };
  if (props.rowData.chargetype === 'Amount') {
    chargeObj = { label: 'Charge (Amount)', value: props.rowData.charge, span: 6 };
  } else {
    chargeObj = { label: 'Charge (Percent)', value: props.rowData.charge, span: 6 };
  }
  const detailData = [
    { label: 'Fee Tax Type', value: props.rowData.feetaxtype, span: 6 },
    { label: 'Application', value: props.rowData.application, span: 6 },
    { label: 'Charge Type', value: props.rowData.chargetype, span: 6 },
    { label: '', value: '', span: 6 },
    chargeObj,
  ]

  const [editFlag, setEditFlag] = useState(false);
  const [addLoading, setAddLoading] = useState(false);


  const [form] = Form.useForm();

  const validateForm = () => {
    form.validateFields().then(() => {
      setDisableFlag(false)
    }).catch(err => {
      err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
    });
  }

  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [chargeName])

  const ModalHead = () => {
    return (
      <div className={styles.modalHead}>Confirm</div>
    )
  }

  const showModal = () => {
    console.log(props)
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content:`Are you sure you want to delete ${props.rowData?.feetaxtype ? props.rowData?.feetaxtype : ''} ?`,            
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk: async() => handleOk(),
      onCancel() {
        setIsModalVisible(false)
      },
    });
  }

  const handleOk = () => {
    setIsModalVisible(false);
    handleDelete()
  };

  const setFormData = (value: any) => {
    let initialValuesCharge = {};
    if (value.chargetype === 'Amount') {
      initialValuesCharge = {
        'Charge (Amount)': value.charge
      }
      setChargeName('Charge (Amount)');
    } else {
      initialValuesCharge = {
        'Charge (Percent)': value.charge
      }
      setChargeName('Charge (Percent)');
    }

    let initialValues = {
      feetaxtype: value.feetaxtype,
      application: value.application,
      chargetype: value.chargetype,
      description: value.description,
      charge: value.charge,
      ...initialValuesCharge
    }
    form.setFieldsValue(initialValues);
    return initialValues
  }

  const addSave = () => {
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence();
      if (value['Charge (Percent)']) {
        value.charge = value['Charge (Percent)'];
        delete value['Charge (Percent)'];
      } else {
        value.charge = value['Charge (Amount)']
        delete value['Charge (Amount)'];
      }
      const params = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "otherpayments": {
            "otherfeetax": [
              {
                ...value,
                "feeid": props.rowData.feeid,
                "feelangid": props.rowData.feelangid
              }
            ]
          }
        }
      }
      setAddLoading(true)
      const formData = setFormData(value)
      const res = await updateOtherFeeTax(params);
      if (res.result.success) {
        setEditFlag(false);
        props.setRowData({ ...props.rowData, ...formData })
      } else {
        message.error({
          content: res?.errors[0]?.message
        });
      }
      setAddLoading(false)
    })
  }

  const handleDelete = async () => {
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    const params = {
      "supplier": session.supplier,
      "propertyId": session.propertyId,
      "property": {
        "otherpayments": {
          "otherfeetax": [
            {
              "feeid": props.rowData.feeid,
              "feelangid": props.rowData.feelangid
            }
          ]
        }
      }
    }
    setAddLoading(true)
    const res = await deleteOtherFeeTax(params);
    if (res.result.success) {
      form.resetFields();
      props.cancelAddAndEdit(true);
    } else {
      message.error({
        content: res?.errors[0]?.message
      });
    }
    setAddLoading(false)
  }

  const editHandle = () => {
    setEditFlag(true);
    let initialValuesCharge = {};
    if (props.rowData.chargetype === 'Amount') {
      initialValuesCharge = {
        'Charge (Amount)': props.rowData.charge
      }
      setChargeName('Charge (Amount)');
    } else {
      initialValuesCharge = {
        'Charge (Percent)': props.rowData.charge
      }
      setChargeName('Charge (Percent)');
    }

    let initialValues = {
      feeid: props.rowData.feeid,
      name: props.rowData.name,
      feelangid: props.rowData.feelangid,
      feetaxtype: props.rowData.feetaxtype,
      application: props.rowData.application,
      chargetype: props.rowData.chargetype,
      // charge: props.rowData.charge,
      description: props.rowData.description,
      ...initialValuesCharge
    }
    form.setFieldsValue(initialValues);
  }

  if (addLoading) return <Loading type='large' />;
  return editFlag ? (
    <PageContainer>
      <Card className='db-page'>
        <Grid container spacing={0} className='py-0'>
          <Grid item xs={12} className='p-0'>
            <div className='db-title-wrap'>
              <div className='db-title'>{props.rowData.feetaxtype}</div>
            </div>
          </Grid>
          <Grid item xs={12} className='db-content-wrap pb-0 px-0 my-0'>
            <Form
              layout='vertical'
              form={form}
              name='basic'
              onValuesChange={validateForm}>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item label='Other Fee Tax Type' name='feetaxtype'>
                    <Select allowClear showSearch>
                      <Option value='Value Added Tax Food Beverage'>
                        Value Added Tax Food Beverage
                      </Option>
                      <Option value='Other Tax'>Other Tax</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label='Application' name='application'>
                    <Select allowClear showSearch>
                      <Option value='Inclusive'>Inclusive</Option>
                      <Option value='Exclusive'>Exclusive</Option>
                      <Option value='Cumulative '>Cumulative </Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name='chargetype'
                    label='Charge Type'
                    rules={[
                      {
                        required: true,
                        message: 'This field is required',
                      },
                    ]}>
                    <Select allowClear onChange={(value) => setChargeName(`Charge (${value})`)}>
                      <Option value='Amount'>Amount</Option>
                      <Option value='Percent'>Percent</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
                <>
                  {chargeName === 'Charge (Amount)' && (
                    <>
                      <Col span={6}>
                        <Form.Item
                          label='Charge (Amount)'
                          name='Charge (Amount)'
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                            {
                              pattern: /^\d*(\.\d*)?$/,
                              message: 'This field should be a number',
                            },
                          ]}>
                          <Input />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </>
                <>
                  {chargeName === 'Charge (Percent)' && (
                    <>
                      <Col span={6}>
                        <Form.Item
                          label='Charge (Percent)'
                          name='Charge (Percent)'
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                            {
                              pattern: /^\d*(\.\d*)?$/,
                              message: 'This field should be a number',
                            },
                          ]}>
                          <Input />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </>
              </Row>
              <Row gutter={24}>
                <Col span={18}>
                  <Form.Item
                    label='Description'
                    name='description'
                    rules={[
                      {
                        max: 300,
                        message:
                          'You have reached the max character length of 300',
                      },
                    ]}>
                    <TextArea
                      maxLength={300}
                      rows={3}
                      placeholder='Description'
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onDelete={showModal}
        onCancel={() => {
          props.cancelAddAndEdit()
          form.resetFields()
        }}
        onSave={addSave}
        disabledSave={disableFlag}
      />
    </PageContainer>
  ) : (
    <PageContainer>
      <Card className='db-page'>
        <Grid container spacing={0} className='py-0'>
          <Grid item xs={12} className='p-0'>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ margin: '0 10px 0 0' }}>
                <Button
                  className='db-edit-btn'
                  onClick={() => {
                    props.cancelAddAndEdit()
                    form.resetFields()
                  }}>
                  Back
                </Button>
              </div>
              <div>
                <Button
                  className='db-edit-btn'
                  onClick={() => {
                    editHandle()
                    props.isEditable()
                    props.disableTabPanes(true)
                  }}>
                  Edit
                </Button>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} className='p-0'>
            <div className='db-title-wrap'>
              <div className='db-title'>{props.rowData.feetaxtype}</div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            className='db-content-wrap pb-0 px-0 my-0 db-ml-10'>
            <Row gutter={24}>
              {detailData.map((item, i) => {
                return item.label ? (
                  <Col span={item.span} key={i} className='db-mb-32'>
                    <DetailItem value={item.value} label={item.label} />
                  </Col>
                ) : (
                  <Col span={item.span} key={i}></Col>
                )
              })}
            </Row>
            <Row gutter={24}>
              <Col span={18}>
                <div style={{ display: 'inline-block', width: '100%' }}>
                  <div
                    style={{
                      width: '100%',
                      fontSize: 12,
                      color: '#999999',
                      height: '24px',
                      fontWeight: 600,
                    }}>
                    Description
                  </div>
                  <TextArea
                    rows={3}
                    placeholder='Description'
                    disabled={true}
                    value={props.rowData.description}
                  />
                </div>
              </Col>
            </Row>
          </Grid>
        </Grid>
      </Card>
    </PageContainer>
  )
}
export default EditOtherFeeTax;
